import { Component, Inject, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-general-content-dialog',
  template: ` <ng-container *ngTemplateOutlet="data.content"></ng-container> `,
})
export class GeneralContentDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { content: TemplateRef<any> },
  ) {}
}
